import { render, staticRenderFns } from "./RoomProgram.vue?vue&type=template&id=6513222f&scoped=true"
import script from "./RoomProgram.vue?vue&type=script&lang=js"
export * from "./RoomProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6513222f",
  null
  
)

export default component.exports